var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("br"),
    _c("br"),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { "text-align": "left" } },
      [
        _c(
          "a-spin",
          { attrs: { spinning: _vm.spinning } },
          [
            _c(
              "a-form",
              { attrs: { form: _vm.form } },
              [
                _c(
                  "a-form-item",
                  {
                    staticStyle: { width: "50%", "font-weight": "bold" },
                    attrs: { label: "学校/单位" },
                  },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "organization",
                            {
                              rules: [
                                { required: true, message: "必填项，不能为空" },
                              ],
                            },
                          ],
                          expression:
                            "['organization', { rules: [{ required: true, message: '必填项，不能为空' }] }]",
                        },
                      ],
                      staticStyle: { width: "167%", "margin-left": "5vw" },
                      on: { input: _vm.handleInput },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    staticStyle: { width: "50%", "font-weight": "bold" },
                    attrs: { label: "第一联系人" },
                  },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "teamLeader",
                            {
                              rules: [
                                { required: true, message: "必填项，不能为空" },
                              ],
                            },
                          ],
                          expression:
                            "['teamLeader', { rules: [{ required: true, message: '必填项，不能为空' }] }]",
                        },
                      ],
                      staticStyle: { width: "167%", "margin-left": "5vw" },
                      on: { input: _vm.handleInput },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    staticStyle: { width: "50%", "font-weight": "bold" },
                    attrs: { label: "联系方式" },
                  },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "phone",
                            {
                              rules: [
                                { required: true, message: "必填项，不能为空" },
                              ],
                            },
                          ],
                          expression:
                            "['phone', { rules: [{ required: true, message: '必填项，不能为空' }] }]",
                        },
                      ],
                      staticStyle: { width: "167%", "margin-left": "5vw" },
                      on: { input: _vm.handleInput },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    staticStyle: { width: "50%", "font-weight": "bold" },
                    attrs: { label: "团队成员" },
                  },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "teamMembers",
                            {
                              rules: [
                                { required: true, message: "必填项，不能为空" },
                              ],
                            },
                          ],
                          expression:
                            "['teamMembers', { rules: [{ required: true, message: '必填项，不能为空' }] }]",
                        },
                      ],
                      staticStyle: { width: "167%", "margin-left": "5vw" },
                      on: { input: _vm.handleInput },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    staticStyle: { width: "50%", "font-weight": "bold" },
                    attrs: { label: "作品名称" },
                  },
                  [
                    _c("a-input", {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "name",
                            {
                              rules: [
                                { required: true, message: "必填项，不能为空" },
                              ],
                            },
                          ],
                          expression:
                            "['name', { rules: [{ required: true, message: '必填项，不能为空' }] }]",
                        },
                      ],
                      staticStyle: { width: "167%", "margin-left": "5vw" },
                      on: { input: _vm.handleInput },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  [
                    _c(
                      "a-upload",
                      {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: [
                              "attachFile",
                              {
                                rules: [
                                  { required: true, message: "请添加文件" },
                                ],
                              },
                            ],
                            expression:
                              "['attachFile', { rules: [{  required: true, message: '请添加文件' }] }]",
                          },
                        ],
                        staticStyle: { "margin-left": "5vw" },
                        attrs: {
                          name: "attachFile",
                          multiple: false,
                          headers: _vm.headers,
                          "before-upload": _vm.beforeUpload,
                        },
                      },
                      [
                        _c(
                          "a-button",
                          [
                            _c("a-icon", { attrs: { type: "upload" } }),
                            _vm._v(" 添加附件 "),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "a-row",
          [
            _c("a-col", { attrs: { "a-col": "", span: "6", align: "middle" } }),
            _vm._v(" "),
            _c(
              "a-col",
              { attrs: { "a-col": "", span: "6", align: "middle" } },
              [
                _c(
                  "a-button",
                  {
                    staticStyle: { "margin-bottom": "5vw" },
                    on: {
                      click: function ($event) {
                        return _vm.handleUrl()
                      },
                    },
                  },
                  [_vm._v("返回")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "a-col",
              { attrs: { "a-col": "", span: "6", align: "middle" } },
              [
                _c(
                  "a-button",
                  {
                    staticStyle: { "margin-bottom": "5vw" },
                    attrs: { type: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.addDrEvent()
                      },
                    },
                  },
                  [_vm._v("提交")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("a-col", { attrs: { "a-col": "", span: "6", align: "middle" } }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }